import React, { Component } from 'react';
import { Modal, Table } from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import { biometricsOption, offersBioList } from '../../../libs/services';

class ModalDetailsBiometrics extends Component{
	constructor(props){
		super(props);

		this.state = {
			show: false,
            columns:[],
            list:[],
            start:"",
            end:""
		}

		this.handleShow  = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
        this.reloadList = this.reloadList.bind(this);
	}

	componentDidMount(){
		this.props.onRef(this);     	
	}

    async reloadList(){
        if(this.state.show){
            var request = await biometricsOption('BIO_F_BIO');
            let columns = [{title:'No. Muestra'},{title:'Nombre'}];
            let list = [];

            if(request !== undefined){
                request.forEach((res)=>{
                    columns.push({title:res.code, id:res.id});
                });
                
            }

            request = await offersBioList(
                        this.state.start,
                        this.state.end,
                        sessionStorage.getItem('health_facilities_id'),
                        'BIO_F_BIO'
                    );

            if(request !== undefined){
                request.forEach((res)=>{
                    var obj = [
                        res.id,
                        res.donor_name
                    ]
                    columns.forEach((col)=>{
                        if(col.id !== undefined){
                            var index = res.bio_list.findIndex(item => item.biometrics_id === col.id);

                            if(index !== -1){
                                obj.push(res.bio_list[index].value);
                            }else{
                                obj.push("");
                            }
                        }
                    })

                    list.push(obj);
                })
                
            }
            this.setState({columns, list})
        }
    }

	async handleShow(){
        await this.setState({show:true,start:this.props.start_date, end:this.props.end_date});
        await this.reloadList();
		
	}

	handleClose(){
		this.setState({
			show:false,
            columns:[],
            list:[],
            start:"",
            end:""
		});
	}


	render(){
		const { t } = this.props;

		return (
			<div>
				<Modal bsSize="lg" dialogClassName="modal-patient" show={this.state.show} onHide={this.handleClose}>
					<Modal.Header closeButton>
						<Modal.Title>Biometría Hematica</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
							<div className="col-xs-12">
								<Table responsive hover>
                                    <thead>
                                        <tr>
                                            {this.state.columns.map((col, i)=>
                                                <th key={i}>{col.title}</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.list.map((list, i)=>
                                            <tr key={i}>
                                                {list.map((l, j)=>
                                                    <td key={j}>{l}</td>
                                                )}
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
							</div>
						</div>
					</Modal.Body>
				</Modal>
			</div>
		)
	}
}

export default ModalDetailsBiometrics;